import decode from 'jwt-decode';
import { useEffect, useState } from 'react';

const KEY = 'echo-si-jwt';

export const useIdentity = () => {
    const localKey = localStorage.getItem(KEY) || null;
    const [token, setToken] = useState<string | null>(localKey);

    useEffect(() => {
        window.addEventListener('storage', (e) => setToken(e.newValue));
        return () => {
            window.removeEventListener('storage', (e) => setToken(e.newValue));
        };
    }, [token]);

    const updateToken = (newValue: string | null) => {
        if(newValue == null) window.localStorage.removeItem(KEY);
        else window.localStorage.setItem(KEY, newValue);
        let event: any = new Event('storage');
        event.newValue = newValue;
        window.dispatchEvent(event);
    };

    const isAuthenticated = () => {
        let isAuthenticated = false;

        if(token) {
            try {
                const decoded: any = decode(token);
                if (decoded.exp < Date.now() / 1000) {
                    isAuthenticated = false;
                } else {
                    isAuthenticated = true;
                }
            } catch (err) {
                isAuthenticated = false;
            }
        }

        if(!isAuthenticated) localStorage.removeItem("echo-si-jwt");

        return isAuthenticated;
    }

    return [token, isAuthenticated(), updateToken];
}